import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./components/Home";
import About from "./components/about";
import Contact from "./components/Contact"

function MainApp(){
    return( 
    
     
       <Routes>
        <Route path="/" element={ <Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
      </Routes>  
    )
}
export default MainApp;